import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  content: string;
  location: string;
}
export function TestimonialCard({
  name,
  role,
  content,
  location
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-slate-100 flex flex-col h-full" data-id="element-27">
      <div className="mb-4 text-teal-500" data-id="element-28">
        <Quote className="h-8 w-8 fill-current opacity-20" data-id="element-29" />
      </div>
      <p className="text-slate-700 italic mb-6 flex-grow leading-relaxed" data-id="element-30">
        "{content}"
      </p>
      <div className="mt-auto border-t border-slate-100 pt-4" data-id="element-31">
        <p className="font-bold text-slate-900" data-id="element-32">{name}</p>
        <p className="text-sm text-teal-600 font-medium" data-id="element-33">{role}</p>
        <p className="text-xs text-slate-500 mt-1" data-id="element-34">{location}</p>
      </div>
    </div>;
}